import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import ErrorBoundary from '../../components/Error/ErrorBoundary';
import DashboardMainPanel from './components/DashboardMainPanel';
import Plan from './scenes/Plan/Plan';
import Risk from './scenes/Risk/Risk';
import Bia from './scenes/Bia/Bia';
import Department from './scenes/Department/Department';
import PlanDocument from './scenes/PlanDocument/PlanDocument';
import Team from './scenes/Team/Team';
import RecoveryStrategy from './scenes/RecoveryStrategy/RecoveryStrategy';
import InvocationLevel from './scenes/InvocationLevel/InvocationLevel';
import Document from './scenes/Document/Document';
import Glossary from './scenes/Glossary/Glossary';
import TestingExercising from './scenes/TestingExercising/TestingExercising';
import PlanPolicy from '../Organisation/scenes/Policy/PlanPolicy';
import { businessInfoSelector } from '../Organisation/OrganisationSelectors';
import { planSelector } from './scenes/Plan/PlanSelectors';
import '../../components/OrganisationMainSection/OrganisationMainSection.scss';
import './Dashboard.scss';

/** Shown in ProcessBar when the scene uses `planScreenTitle` (aligned with header breadcrumb labels). */
const PLAN_ROUTE_SCREEN_TITLES = Object.freeze({
  plans: 'Plans',
  'business-units': 'Business Units',
  teams: 'Teams',
  policy: 'Accountable Members',
  risk: 'Enterprise Risk',
  'business-impact-analysis': 'Business Impact Analysis',
  'recovery-strategy': 'Recovery Strategy',
  'plan-document': 'Business Continuity Plan',
  'testing-exercising': 'Testing & Exercising',
  documents: 'Plan Documents',
  'activation-levels': 'Activation Levels',
  glossary: 'Glossary'
});

const routes = Object.freeze([
  { route: 'plans', component: <Plan /> },
  { route: 'business-units', component: <Department /> },
  { route: 'teams', component: <Team /> },
  { route: 'policy', component: <PlanPolicy /> },
  { route: 'risk', component: <Risk /> },
  { route: 'business-impact-analysis', component: <Bia /> },
  { route: 'recovery-strategy', component: <RecoveryStrategy /> },
  { route: 'plan-document', component: <PlanDocument /> },
  { route: 'testing-exercising', component: <TestingExercising /> },
  { route: 'documents', component: <Document /> },
  { route: 'activation-levels', component: <InvocationLevel /> },
  { route: 'glossary', component: <Glossary /> }
]);

const Dashboard = props => {
  const { match, businessInfo, currentPlan } = props;

  // Check if businessInfo exists and has 'name' property
  const hasBusinessInfo = businessInfo && typeof businessInfo === 'object' && 'name' in businessInfo;
  
  // Check if currentPlan exists and has 'planId' property
  const hasCurrentPlan = currentPlan && typeof currentPlan === 'object' && 'planId' in currentPlan;

  const renderContent = () => {
    if (!hasBusinessInfo) {
      return <Redirect to="/organization" />;
    }
    
    if (!hasCurrentPlan) {
      return <Plan />;
    }

    return (
      <Switch>
        <Route exact path={match.url} component={DashboardMainPanel} />
        {routes.map(item => {
          const planScreenTitle = PLAN_ROUTE_SCREEN_TITLES[item.route];
          const componentToRender = React.cloneElement(item.component, {
            ...props,
            ...(planScreenTitle != null ? { planScreenTitle } : {})
          });
          return (
            <Route
              key={item.route}
              path={`${match.url}/${item.route}`}
              render={() => (
                <ErrorBoundary>
                  <div className="organisation-main-section organisation-main-section--plan">{componentToRender}</div>
                </ErrorBoundary>
              )}
            />
          );
        })}
        <Redirect to="/not-found" />
      </Switch>
    );
  };

  return (
    <Layout hasSider>
      {renderContent()}
    </Layout>
  );
};

const mapStateToProps = state => ({
  businessInfo: businessInfoSelector(state),
  currentPlan: planSelector(state)
});

export default connect(mapStateToProps)(Dashboard);
